import { apiRequest, getApiBaseUrl } from './api.js';

export async function facebookConfig() {
  const data = await apiRequest('/integrations/facebook/config');
  return data?.data || { connected: false };
}

export function facebookLoginUrl() {
  const back = `${window.location.origin}/bms`;
  return `${getApiBaseUrl()}/integrations/facebook/login?return=${encodeURIComponent(back)}`;
}

export async function completeFacebookOAuth(payload) {
  return apiRequest('/integrations/facebook/complete', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function connectFacebook(payload) {
  return apiRequest('/integrations/facebook/connect', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function importFacebookBms(ids) {
  return apiRequest('/integrations/facebook/bms/import', {
    method: 'POST',
    body: JSON.stringify({ ids }),
  });
}

export async function syncFacebookBm(id) {
  return apiRequest(`/integrations/facebook/bms/${id}/sync`, {
    method: 'POST',
    body: '{}',
  });
}

export async function syncFacebookCampaigns() {
  return apiRequest('/integrations/facebook/campaigns/sync', {
    method: 'POST',
    body: '{}',
  });
}

export async function updateFacebookCampaign(id, payload) {
  return apiRequest(`/integrations/facebook/campaigns/${encodeURIComponent(id)}`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
